// Before/After slider — drag anywhere on the frame, pointer or touch
function initBA(ba) {
  let drag = false;
  const hint = ba.querySelector('.ba-hint');
  const set = (clientX) => {
    const r = ba.getBoundingClientRect();
    let p = (clientX - r.left) / r.width;
    p = Math.max(0, Math.min(1, p));
    ba.style.setProperty('--pos', (p * 100) + '%');
  };
  const down = (e) => {
    drag = true;
    if (hint) hint.classList.add('hint-dismissed');
    set((e.touches ? e.touches[0] : e).clientX);
  };
  const move = (e) => {
    if (!drag) return;
    set((e.touches ? e.touches[0] : e).clientX);
    if (e.cancelable) e.preventDefault();
  };
  const up = () => drag = false;

  ba.addEventListener('mousedown', down);
  ba.addEventListener('touchstart', down, { passive: true });
  window.addEventListener('mousemove', move);
  window.addEventListener('touchmove', move, { passive: false });
  window.addEventListener('mouseup', up);
  window.addEventListener('touchend', up);
}

document.querySelectorAll('.ba').forEach(initBA);
